<template>
  <v-card class="card mt-3">
    <v-container>
      <div class="card--headline card-title ">
        #{{ id }} - {{ site }}
        <span class="body-2">({{ problemType }})</span>
        <span class="ml-1 mr-auto">
          <v-icon
            v-if="completed"
            color="green lighten-2"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
          <v-icon
            v-if="!completed"
            color="grey"
          >
            mdi-checkbox-marked-circle-outline</v-icon>
        </span>
        <span class="body-2 ml-auto caption">{{ created_at }}</span>
      </div>
      <v-layout class=" mt-2">
        <span class="caption">描述:{{ description }}</span>
      </v-layout>
      <v-layout class="mt-2">
        <span class="caption">維修次數: {{ repairItems }}</span>
      </v-layout>
      <v-divider class="mt-3 mb-2"></v-divider>
      <v-card-actions class="px-0 card-action">
        <v-btn
          :to="`/show/${id}`"
          small
          depressed
          outlined
          class=" mr-auto cyan--text text--darken-4"
        >檢視維修單</v-btn>
        <v-btn
          v-if="!completed && repairItems > 0"
          :to="`/finish/${id}`"
          small
          depressed
          color="cyan darken-4"
          class="white--text"
        >填寫簽收單</v-btn>
        <v-btn
          v-if="!completed"
          :to="`/show/${id}/new-item`"
          small
          depressed
          color="cyan darken-4"
          class="white--text"
        >增加維護單</v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "Card",
  props: [
    "id",
    "site",
    "completed",
    "problemType",
    "created_at",
    "description",
    "repairItems"
  ],
  data: () => ({})
};
</script>
